import * as React from 'react';

import { IMarketSelector } from '../types';

import { Button, Input, Icons } from 'src/components';

const { useState } = React;
const MARKETS_SEARCH_THRESHOLD = 2;

const MarketSelector: React.FC<IMarketSelector> = ({
  markets,
  checkedItems,
  onToggleMarket,
  children,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleMarkets, setVisibleMarkets] = useState(markets);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const filteredMarkets =
      value === ''
        ? markets
        : markets.filter(
            market =>
              market.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
          );
    setSearchTerm(value);
    setVisibleMarkets(filteredMarkets);
  };

  return (
    <>
      <div className="mb-3">{children}</div>
      <div className="flex">
        <Button
          size="small"
          background="grey"
          disabled={checkedItems.length === markets.length}
          className="mr-2"
          onClick={onToggleMarket(true)}
        >
          All
        </Button>
        <Button
          size="small"
          background="grey"
          disabled={checkedItems.length === 0}
          className="mr-3"
          onClick={onToggleMarket(false)}
        >
          None
        </Button>
        {markets.length >= MARKETS_SEARCH_THRESHOLD && (
          <div className="flex-1 relative">
            <span className="absolute pin-t pin-l leading-normal mt-2 ml-3 pointer-events-none">
              <Icons.Search size={16} />
            </span>
            <Input
              value={searchTerm}
              onChange={handleSearch}
              name="search"
              placeholder="Search"
              className="w-full pl-10"
              small={true}
              autoComplete="off"
            />
          </div>
        )}
      </div>

      <div className="my-3 py-1 max-h-sm overflow-auto">
        {visibleMarkets.map(market => {
          const possibleChecked = checkedItems.find(el => el.id === market.id);
          const isChecked = Boolean(possibleChecked);
          return (
            <button
              key={market.id}
              type="button"
              className={`${
                isChecked ? 'bg-green' : 'bg-white hover:bg-grey-lighter'
              } py-2 px-4 mr-1 mb-1 focus:outline-none`}
              onClick={onToggleMarket(market, isChecked)}
            >
              {market.name}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default MarketSelector;



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/MarketSelector.tsx